// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"VZSITb9C4jKe5RCVvAaGnA==","LogoExtra":"pCV7KLVK7VuuiVdlS4H8Gg=="};